import Button from "@mui/material/Button";
import FullScreenModal from "components/common/FullScreenModal";
import StatusHandler from "components/common/StatusHandler";
import { ACTION_STATES } from "core/actions";
import { assertObject } from "core/validation";
import { get } from "lodash";
import log from "loglevel";
import React, { useRef } from "react";
import { connect } from "react-redux";
import FilmReleaseForm from "./FilmReleaseForm";
import { DeleteFilmBtn } from "./filmCommon";
import { actions, actions as filmsActions } from "./logic/filmFormActions";

import { Paths } from "components/common/navigation";
import { useLocation } from "react-router-dom";

function FilmReleaseModal(props) {
    const {
        onCloseModal,
        addStatus,
        editStatus,
        editing,
        addFilmRelease,
        onMergeFilmRelease,
        editFilmRelease,
        mergingStatus,
        initValues,
        associationStatus,
        onRequestAssociation,
        onAddFromExisting,
        creatingNew,
        open,
    } = props;
    log.debug(editing);
    const filmReleaseFormRef = useRef();

    const location = useLocation();
    const canShowDelete = React.useMemo(() => {
        return location.pathname === Paths.FILM;
    }, [location.pathname]);
    function handleClose() {
        onCloseModal();
    }

    function handleOnDelete() {
        handleClose();
    }
    function submitForm() {
        filmReleaseFormRef.current.submitForm();
    }
    if (!open) {
        return null;
    }
    const isMergin = mergingStatus === ACTION_STATES.SEND;
    const isCreatingNew = creatingNew === ACTION_STATES.SEND;
    const loading = isMergin || isCreatingNew;

    const deleteBtnProps = {
        style: { marginRight: 15 },
    };
    const showDeleteBtn = !loading && open && editing && assertObject(initValues) && canShowDelete;
    const filmName = showDeleteBtn ? get(initValues, "title.label", "") : "";
    const btns = (
        <>
            {showDeleteBtn && (
                <DeleteFilmBtn
                    btnProps={deleteBtnProps}
                    onDelete={handleOnDelete}
                    filmReleaseId={initValues.id}
                    filName={filmName}
                />
            )}
            <Button variant={"contained"} size={"small"} color={"secondary"} onClick={submitForm}>
                Save
            </Button>
        </>
    );
    return (
        <FullScreenModal
            btns={btns}
            title={`${!editing ? "ADD" : "EDIT"} FILM RELEASE`}
            open={open}
            handleClose={handleClose}
        >
            <StatusHandler 
                status={mergingStatus} 
                showLoading 
                loadingMessage={"Merging films"} 
                successMessage={"The operation was made successfully"}
            />
            <StatusHandler
                status={associationStatus}
                showLoading
                loadingMessage={"Doing association "}
                successMessage={"The operation was made successfully"}
            />
            {!loading && open && (
                <FilmReleaseForm
                    ref={filmReleaseFormRef}
                    addStatus={addStatus}
                    onAddFromExisting={onAddFromExisting}
                    editStatus={editStatus}
                    onMergeFilmRelease={onMergeFilmRelease}
                    editing={editing}
                    onRequestAssociation={onRequestAssociation}
                    addFilmRelease={addFilmRelease}
                    editFilmRelease={editFilmRelease}
                    initValues={initValues}
                />
            )}
        </FullScreenModal>
    );
}

const mapStateToProps = ({ filmReleaseForm }) => ({
    addStatus: filmReleaseForm.addStatus,
    editStatus: filmReleaseForm.editStatus,
    editing: filmReleaseForm.editing,
    initValues: filmReleaseForm.values,
    mergingStatus: filmReleaseForm.mergingStatus,
    associationStatus: filmReleaseForm.associationStatus,
    creatingNew: filmReleaseForm.creatingNew,
    filmRelease: filmReleaseForm.filmRelease,
    open: filmReleaseForm.open,
});

function mapDispatchToProps(dispatch) {
    return {
        addFilmRelease: (values, callback) => dispatch(actions.ADD_FILM_RELEASE.send({ values, callback })),
        editFilmRelease: (values, callback) => dispatch(actions.EDIT_FILM_RELEASE.send({ values, callback })),
        onMergeFilmRelease: (sourceFilmR, targetFilmR) =>
            dispatch(actions.MERGE_FILM_RELEASE.send({ sourceFilmR, targetFilmR })),
        onRequestAssociation: (sourceFilmR, targetFilmR) =>
            dispatch(actions.ASSOCIATION_FILM_RELEASE.send({ sourceFilmR, targetFilmR })),
        onAddFromExisting: (filmRelease) =>
            dispatch(actions.TOGGLE_FILM_RELEASE_FORM.send({ reopen: true, filmRelease, editing: false })),
        onCloseModal: () => dispatch(filmsActions.TOGGLE_FILM_RELEASE_FORM.send({ reopen: false })),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FilmReleaseModal);
